import { Component, inject, NgZone } from '@angular/core';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { LoadingState } from '../store/models/loader.model';
import { Subscription, TeardownLogic } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { regexp } from '../store/models/regex';
import { Title } from '@angular/platform-browser';
import { UiService } from '../services/ui.service';
import { Location } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { environment } from '../../../environments/environment';

@Component({ template: '' })
export abstract class BasicComponent {
  environment = environment;
  protected readonly ar = inject(ActivatedRoute);
  protected readonly router = inject(Router);
  protected readonly store = inject(Store);
  protected readonly auth = inject(AuthService);
  protected readonly title = inject(Title);
  protected readonly ui = inject(UiService);
  protected readonly zone = inject(NgZone);
  protected readonly location = inject(Location);
  public breadcrumb: MenuItem[] | undefined;
  public loadingState = LoadingState;
  protected subs = new Subscription();
  public regexp = regexp;

  back() {
    this.location.back();
  }

  observe(teardown: TeardownLogic) {
    this.subs.add(teardown);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
